import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThickDown = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15.9996 22.9997C16.2624 22.9998 16.5226 22.948 16.7654 22.8474C17.0082 22.7468 17.2288 22.5994 17.4146 22.4135L27.4146 12.4135C27.6002 12.2277 27.7475 12.0071 27.8479 11.7644C27.9483 11.5217 27.9999 11.2615 27.9998 10.9989C27.9997 10.7362 27.9478 10.4761 27.8472 10.2335C27.7466 9.99083 27.5992 9.7704 27.4133 9.58474C27.2275 9.39908 27.0069 9.25184 26.7642 9.15143C26.5215 9.05102 26.2614 8.9994 25.9987 8.99951C25.736 8.99963 25.476 9.05148 25.2333 9.15211C24.9907 9.25274 24.7702 9.40017 24.5846 9.58599L15.9996 18.171L7.41459 9.58599C7.03947 9.21087 6.53071 9.00014 6.00021 9.00014C5.46972 9.00014 4.96095 9.21087 4.58584 9.58599C4.21072 9.9611 3.99998 10.4699 3.99998 11.0004C3.99998 11.5309 4.21072 12.0396 4.58584 12.4147L14.5858 22.4147C14.9609 22.7894 15.4694 22.9998 15.9996 22.9997Z" />
	</svg>
);

export default ChevronThickDown;
